import { useEffect, useState } from 'react'
import { parseReservationExpiresAt } from 'lib/experiences/experienceReservationUtils'

export function useExperienceReservationExpiryTimer(reservationExpiresAt: string | undefined, maxRemainingSeconds?: number) {
  const [now, setNow] = useState(Date.now())
  const expiryTimestamp = parseReservationExpiresAt(reservationExpiresAt)

  useEffect(() => {
    if (expiryTimestamp === undefined) return
    const updateNow = () => setNow(Date.now())
    updateNow()
    const interval = setInterval(updateNow, 1000)
    document.addEventListener('visibilitychange', updateNow)
    return () => {
      clearInterval(interval)
      document.removeEventListener('visibilitychange', updateNow)
    }
  }, [expiryTimestamp])

  const remainingMilliseconds = expiryTimestamp === undefined ? 0 : Math.max(0, expiryTimestamp - now)
  const remainingSeconds = Math.floor(remainingMilliseconds / 1000)
  const timeRemaining = remainingSeconds > 0 && (maxRemainingSeconds === undefined || remainingMilliseconds <= maxRemainingSeconds * 1000)
    ? { minutes: Math.floor(remainingSeconds / 60), seconds: remainingSeconds % 60 }
    : undefined

  return { timeRemaining }
}
